import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/documents')({
	staticData: { breadcrumb: 'po:page_title' },
	component: () => <Outlet />
})
